import { render } from "./AboutQuantumReadinessChatbot.vue?vue&type=template&id=728f4044"
import script from "./AboutQuantumReadinessChatbot.vue?vue&type=script&lang=js"
export * from "./AboutQuantumReadinessChatbot.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__